import React, { BaseSyntheticEvent, MouseEventHandler } from 'react';
import { ApolloError } from '@apollo/client';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { getErrorMessage } from '@occc/utils';
import { useUserSelector } from '@occc-app/App/AppContext';
import { authService } from '@occc-app/Auth/authService';

import { useMagicLinkLogoutMutation } from './hooks';
import { prepareUserData } from './utils';
import { MyAccountButton } from './MyAccountButton';
import { MyAccountPopover } from './MyAccountPopover';

import { snackbar } from '../../../snackbar';

export const MyAccountContainer = () => {
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<HTMLElement | null>(null);
  const [open, setOpen] = React.useState(false);

  const handleMenuOpen: MouseEventHandler<HTMLElement> = (event: BaseSyntheticEvent) => {
    setMenuAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const handleMenuClose = () => {
    setOpen(false);
  };

  const onLogoutError = async (error: ApolloError) => {
    if (error.message === 'Expired token') {
      await authService.clearSession();
    } else {
      snackbar.error(getErrorMessage(error));
    }
  };

  const onLogoutCompleted = async (response: any) => {
    if (response) {
      await authService.clearSession();
    } else {
      snackbar.error('Something went wrong. Please try again.');
    }
  };
  const logout = useMagicLinkLogoutMutation(onLogoutError, onLogoutCompleted);

  const user = useUserSelector();
  const preparedUser = prepareUserData(user);

  return (
    <>
      <MyAccountButton handleMenuOpen={handleMenuOpen} isMenuOpen={open} />
      <MyAccountPopover
        logout={logout}
        user={preparedUser}
        handleMenuClose={handleMenuClose}
        menuAnchorEl={menuAnchorEl}
        isMenuOpen={open}
      />
    </>
  );
};
